import { useIntl } from "@grandvisionhq/state";
const useSubscriptionIntervalOptions = (deliveryIntervals, subscriptionDeliveryIntervalsFallback) => {
  const { getFormattedLabel } = useIntl();
  if (!deliveryIntervals?.length && !subscriptionDeliveryIntervalsFallback?.length) {
    return void 0;
  }
  const unformattedDeliveryOptions = deliveryIntervals?.length ? deliveryIntervals : subscriptionDeliveryIntervalsFallback || [];
  const deliveryIntervalOptions = unformattedDeliveryOptions.reduce(
    (acc, interval) => {
      const key = getFormattedLabel("products.subscriptions.deliveryInterval.option", {
        labelData: { days: interval }
      });
      return {
        ...acc,
        [key]: interval
      };
    },
    {}
  );
  return deliveryIntervalOptions;
};
export {
  useSubscriptionIntervalOptions
};
//# sourceMappingURL=use-subscription-interval-options.js.map
